import { TransactionTypeChar } from '@tassat/common-definitions';
import { AccountRecord } from '@tassat/fred-definitions';
import { TransactionHistoryRecord } from '@tassat/fred-extended-definitions';
import { createSelector } from 'reselect';

import { AdminState } from 'Reducers/store/adminStore';
import { ClientState } from 'Reducers/store/clientStore';

import {
    getAccounts,
    getPendingTransactionList,
    getSelectedAccountId,
    getTransactionList
} from './common';

export const clientTransactionsMapping = createSelector(
    [ getTransactionList, getAccounts, getSelectedAccountId ],
    (transactionList, accounts, selectedAccountId) => {
        const transactions: TransactionHistoryRecord[] = Object.keys(transactionList)
            .map(id => transactionList[id]);

        const selectedAccount: AccountRecord = accounts[selectedAccountId];

        return transactions.filter(tx => {
            if (
                tx.type === TransactionTypeChar.deposit ||
                tx.type === TransactionTypeChar.order ||
                tx.type === TransactionTypeChar.int_distribution ||
                tx.type === TransactionTypeChar.withdrawal
            ) {
                return true;
            }
            if (selectedAccount && selectedAccount.Account === tx.SenderAddress && tx.type !== TransactionTypeChar.send) {
                return false;
            }

            if (selectedAccount && selectedAccount.Account === tx.RecipientAddress && tx.type !== TransactionTypeChar.receive) {
                return false;
            }

            if (!selectedAccount && tx.type === TransactionTypeChar.receive && transactionList[`${tx.RequestId}-${TransactionTypeChar.send}`]) {
                return false;
            }

            return true;
        });
    }
);

export const clientCompletedTransactionsMapping = createSelector(
    [clientTransactionsMapping],
    (transactions) => transactions.filter(tx => tx.IsCompleted)
);

export const clientPendingTransactionsMapping = createSelector(
    [ getPendingTransactionList, getAccounts, getSelectedAccountId ],
    (transactionList, accounts, selectedAccountId) => {
        const transactions: TransactionHistoryRecord[] = Object.keys(transactionList)
            .map(id => transactionList[id]);

        const selectedAccount: AccountRecord = accounts[selectedAccountId];

        return transactions.filter(tx => {
            if (
                tx.type === TransactionTypeChar.deposit ||
                tx.type === TransactionTypeChar.send ||
                tx.type === TransactionTypeChar.receive ||
                tx.type === TransactionTypeChar.order ||
                tx.type === TransactionTypeChar.withdrawal
            ) {
                return true;
            }
            if (selectedAccount && selectedAccount.Account === tx.SenderAddress && tx.type !== TransactionTypeChar.send) {
                return false;
            }

            if (selectedAccount && selectedAccount.Account === tx.RecipientAddress && tx.type !== TransactionTypeChar.receive) {
                return false;
            }

            if (!selectedAccount && tx.type === TransactionTypeChar.receive && transactionList[`${tx.RequestId}-${TransactionTypeChar.send}`]) {
                return false;
            }

            return true;
        });
    }
);

export const adminTransactionsMapping = createSelector([getTransactionList], (transactionList) => {
    const transactions: TransactionHistoryRecord[] = Object.keys(transactionList)
        .map(id => transactionList[id]);

    return transactions;
});

export const getTransactionsRealtimeHalted = (state: AdminState | ClientState): boolean => {
    return state.transactions.haltRealtimeTransactions;
};

const getSelectedTransactionId = (_state: AdminState | ClientState, selectedTransactionId: string) => selectedTransactionId;

export const getTransactionById = createSelector(
    [ getTransactionList, getSelectedTransactionId ],
    (transactions, selectedTransactionId): TransactionHistoryRecord => {
        return transactions[selectedTransactionId];
    }
);